module.exports = __webpack_public_path__ + "img/review.2f6c83e3.svg";